interface Config {
  serverPort: number;
}

const config: Config = {
  serverPort: <number>import.meta.env.VITE_SERVER_PORT,
};

export default config;
